import { HabilitationIssuerKindEnum } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

export const CreateUpdateHabilitationTypeSchema = z.object({
  label: z.string().min(1),
  description: z.string().nullable().default(null),
  periodicityYears: z.number().int().positive().nullable(),
  issuerKind: z
    .nativeEnum(HabilitationIssuerKindEnum)
    .default(HabilitationIssuerKindEnum.EITHER),
  requiresTraining: z.boolean().default(false),
});

export class HabilitationTypeCreateUpdateDto extends createZodDto(
  CreateUpdateHabilitationTypeSchema,
) {}
